<template>
    <b-container class="projects-wrapper">
        <b-row>
            <b-col>
                <h1 class="float-left">Your Draft Projects</h1>
                <b-button @click="newProject" class="green float-right">Start New Project</b-button>
            </b-col>
        </b-row>

        <b-row>

            <b-col>
                <b-card>
                    <nav class="float-right">
                        <b-pagination v-if="totalRows > perPage" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>

                    <b-table id="project-list" :items="myProvider" :fields="fields"  borderless :current-page="currentPage" :per-page="perPage" responsive>
                        <template v-slot:cell(prompts)="data">
                            {{(data.item.prompts) ? data.item.prompts.length : 0}}
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{timestamp(data.item.created_at)}}
                        </template>
                        <template v-slot:cell(amount)="data">
                            ${{total(data.item).toFixed(2)}}
                        </template>
                        <template v-slot:cell(actions)="data">
                            <div class="text-right">
                                <b-button size="sm" variant="primary" @click="goToProject(data.item)"><font-awesome-icon icon="edit" /> Edit</b-button>
                                <b-button size="sm" variant="danger" @click="remove(data.item)">
                                    <font-awesome-icon v-if="removing !== data.item.uuid" icon="trash" />
                                    <font-awesome-icon v-if="removing === data.item.uuid" icon="spinner" pulse />
                                     Delete
                                </b-button>
                            </div>
                        </template>
                    </b-table>

                    <nav class="float-right">
                        <b-pagination v-if="totalRows > perPage" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>

                    <div class="mt-5" v-if="$store.getters['project/items'].length < 1 && !isBusy">
                        <h2 class="text-center">Start creating projects by clicking the "Start New Project" button</h2>
                    </div>
                </b-card>

            </b-col>

        </b-row>

        <get-started-modal></get-started-modal>
    </b-container>
</template>
<script>
    import GetStartedModal from '../modals/GetStartedModal'
    import moment from 'moment-timezone'
    export default {
        components: {
            GetStartedModal
        },
        data() {
            return {
                projects: [],
                fields: [
                    {key: 'name'},
                    {key: 'talent.persona', label: 'Talent'},
                    {key: 'word_count', label: 'Words', class: 'text-center', thStyle: 'width: 90px;'},
                    {key: 'prompts', label: 'Prompts', class: 'text-center', thStyle: 'width: 90px;'},
                    {key: 'amount', label: 'Total', class: 'text-center', thStyle: 'width: 90px;'},
                    {key: 'created_at', label: 'Created', thStyle: 'width: 130px;'},
                    {key: 'actions', label: '', thStyle: 'width: 165px'}
                ],
                items: [],

                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                isBusy: true,
                removing: false,

                status: 'Draft',

                initialLoad: false
            };
        },
        methods: {
            goToProject: function(project) {
                this.$store.commit('project/removeCurrent')
                this.$store.commit('prompt/clear')

                if(project.status == 'draft') {
                    return this.$router.push({name: 'project_id', params: { id: project.uuid }})
                }

                this.$router.push({name: 'review', params: { id: project.uuid }});
            },
            async remove (project) {
                try {
                    this.removing = project.uuid
                
                    const res = await this.$store.dispatch('project/delete', project.uuid)

                    this.$root.$emit('bv::refresh::table', 'project-list')
                } catch (ex) {

                }

                this.removing = false
            },
            timestamp (timestamp) {
                return moment.utc(timestamp, 'YYYY-MM-DD HH:mm:ss').local().format('MM/DD/YYYY')
            },
            total (project) {
                return parseFloat(project.amount) + parseFloat(project.record_fee)
            },
            newProject () {
                this.$store.commit('project/removeCurrent')
                this.$store.commit('prompt/clear')
                this.$router.push({name: 'new'})
            },
            async myProvider (ctx, callback) {
                try {
                    let data = {
                        page: ctx.currentPage,
                        limit: ctx.perPage
                    };

                    /* if (this.searchTerm && this.searchTerm !== "") {
                        data.search_term = this.searchTerm;
                    } */

                    data.status = this.status.toLowerCase();

                    this.$router.push({ query: data });

                    const res = await this.$store.dispatch("project/fetch", data);

                    // Pluck the array of items off our axios response
                    this.items = res.records;
                    this.totalRows = res.record_count ? res.record_count : 0;

                    /* if (this.searchTerm && this.searchTerm !== "") {
                        this.totalRows = res.records.length;
                    } */

                    /* if ((this.totalRows == 0 && this.prevRoute && this.prevRoute.name === 'login') {
                        this.$bvModal.show('get-started-modal');
                    } */

                    this.isBusy = false

                    return this.items || [];

                } catch (ex) {
                    console.log(ex.message || ex);

                    return []
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (from && from.name === 'login') {
                    vm.$bvModal.show('get-started-modal')
                }
            })
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/project/List.vue